import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input", "icon"]

  connect() {
    this.toggleIcon()
  }

  toggle() {
    if (this.inputTarget.type === "password") {
      this.inputTarget.type = "text"
    } else {
      this.inputTarget.type = "password"
    }
    this.toggleIcon()
  }

  toggleIcon() {
    this.iconTargets.forEach((icon, index) => {
      if (this.inputTarget.type === "password") {
        // Show eye icon (first icon)
        icon.classList.toggle("hidden", index !== 0)
      } else {
        // Show eye-slash icon (second icon)
        icon.classList.toggle("hidden", index !== 1)
      }
    })
  }
}
